import { Card } from 'canoe';
import React from 'react';

import { SelectContentTypeForm } from './components/SelectContentTypeForm';
import { Stepper } from './components/Stepper';
import { WizardView } from './components/WizardView';

interface SelectContentTypeProps {
  onSelect?: (contentType: string) => void;
}

export const SelectContentTypeWithoutTemplate = ({ onSelect }: SelectContentTypeProps) => {
  const onSubmit = (payload: { contentType: string }) => {
    onSelect?.(payload.contentType);
  };

  return (
    <Card size="xl">
      <Stepper currentStep={1} />
      <WizardView title="Create Content" subTitle="Let's start by choosing your Content Type">
        <SelectContentTypeForm onSubmit={onSubmit} />
      </WizardView>
    </Card>
  );
};
